import { useCallback, useLayoutEffect, useState } from 'react';

export const useIsMobile = (callback) => {
  const getIsMobile = () => {
    const width = Math.min(window.innerWidth, window.screen.availWidth || window.innerWidth);
    return width <= 991;
  };

  const [isMobile, setIsMobile] = useState(getIsMobile);

  const handleResize = useCallback(() => {
    const mobile = getIsMobile();
    setIsMobile(mobile);
    if (callback) callback(mobile);
  }, [callback]);

  useLayoutEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return isMobile;
};
